module.exports = __webpack_public_path__ + "img/features_scoremaster_phone_mobile1.6b40366d.jpg";